export const Dribbble = (props: SocialIconProps) => {
  const { className } = props;

  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 64 64" className={className}>
      <rect
        width={62}
        height={62}
        x={1.5}
        y={1}
        strokeWidth={2}
        className="fill-surface-secondary stroke-skin-stroke"
        rx={31}
      />
      <path
        className="stroke-skin-primary"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M45.833 32a13.29 13.29 0 0 1-3.926 9.449 13.29 13.29 0 0 1-9.407 3.884c-7.364 0-13.333-5.969-13.333-13.333a13.288 13.288 0 0 1 3.666-9.183 13.297 13.297 0 0 1 9.667-4.15 13.293 13.293 0 0 1 9.407 3.884A13.291 13.291 0 0 1 45.833 32Z"
      />
      <path
        className="stroke-skin-primary"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M45.833 32c-1.945 0-7.312-.733-12.115 1.375-5.218 2.292-8.996 5.846-10.643 8.056"
      />
      <path
        className="stroke-skin-primary"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M27.5 19.636c2.087 1.926 6.64 6.83 8.333 11.697 1.694 4.868 2.32 10.854 2.707 12.557"
      />
      <path
        className="stroke-skin-primary"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M19.27 30.333c2.518.152 9.186.289 13.452-1.533 4.267-1.822 7.938-5.173 9.197-6.237M20.168 37.075a13.384 13.384 0 0 0 6 6.661"
      />
      <path
        className="stroke-skin-primary"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M19.167 32a13.288 13.288 0 0 1 3.666-9.183 13.297 13.297 0 0 1 9.667-4.15m5.333 1.109c1.519.664 2.9 1.605 4.074 2.775A13.291 13.291 0 0 1 45.833 32c0 1.641-.296 3.214-.84 4.667M32.5 45.333a13.291 13.291 0 0 0 9.407-3.884"
      />
    </svg>
  );
};
